import { render, staticRenderFns } from "./AdminUserList.vue?vue&type=template&id=28b00a1a&scoped=true&"
import script from "./AdminUserList.vue?vue&type=script&lang=js&"
export * from "./AdminUserList.vue?vue&type=script&lang=js&"
import style0 from "./AdminUserList.vue?vue&type=style&index=0&id=28b00a1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b00a1a",
  null
  
)

export default component.exports